export default __webpack_public_path__ + "static/media/compare-profit-min.113eef7e.png";